import chat5 from '../../assets/images/courses/teamplayer&collaboration/chat/chat_question5.png';
import chat1 from '../../assets/images/courses/teamplayer&collaboration/chat/question01.png';
import chat6 from '../../assets/images/courses/teamplayer&collaboration/chat/question2.png';
import chat3 from '../../assets/images/courses/teamplayer&collaboration/chat/question3.png';
import chat4 from '../../assets/images/courses/teamplayer&collaboration/chat/question4.png';
import chat2 from '../../assets/images/courses/teamplayer&collaboration/chat/question6.png';
import {
  CourseChatQuestion,
  CourseQuestion,
  CourseSortingQuestion,
  QuestionType,
} from '../jumpstart-communicator/jumpstart-communicator.types';

export const course_chat_questions: CourseChatQuestion[] = [
  // 0
  {
    title: 'Scenario: Risky Shift',
    content:
      'You´re part of a group project where the team is considering taking a big risk to meet a tight deadline.',
    id: '97asw-6d54-4fe5-94df-b093eba9e021',
    question: '',
    question_img: 'intro',
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content:
      'Carlos suggests: "Hey everyone, I think we should consider taking a big risk to meet our deadline."',
    id: '65awd2-6d54-4fe5-94df-b093eba934151',
    question: '',
    question_img: chat1,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content:
      'Stephen expresses his concern: "Hmm, I´m not sure about that. What if things go wrong?"',
    id: '71b923f9-6d54-4fe5-94df-b093eba934151',
    question: '',
    question_img: chat6,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content: 'Dacia replies: "Don´t worry, if anything goes south, we´re all in this together."',
    id: '8663df-6d54-4fe5-94df-b093eba934151',
    question: '',
    question_img: chat3,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content:
      'Val expressing her excitement: "Yeah, let´s go for it! We can handle whatever comes our way."',
    id: '23iayz-6d54-4fe5-94df-b093eba934151',
    question: '',
    question_img: chat4,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content:
      'Michel, the team leader says:  "Alright, it seems like everyone´s on board. Let´s take the risk and get this done."',
    id: 'fq0923-6d54-4fe5-94df-b093eba934151',
    question: '',
    question_img: chat5,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  // 1
  // {
  //   id: '400a9165-b5c9-4962-874e-de9bc4b7ff7b',
  //   question:
  //     'Step 2: Authentic praise. Which response would demonstrate Kevin providing authentic praise? ',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: 'a1334757-e7d0-4084-8b18-5c135eed8128',
  //       option:
  //         '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
  //       description: '',
  //       img: 'charImage3',
  //     },
  //     {
  //       id: 'ca2c8cac-9ef6-4fd5-af23-84b2f5cd1e04',
  //       option: '"You were okay, I guess."',
  //       description: '',
  //       img: 'charImage2',
  //     },
  //   ],
  //   answer:
  //     '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
  //   answers: ['a1334757-e7d0-4084-8b18-5c135eed8128'],
  //   answer_description:
  //     '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 2
  // {
  //   id: 'f28579cd-5149-4492-9c15-add68f61f47e',
  //   question:
  //     'Jane decides that Mary simply couldn’t be bothered to turn up on time, and that Mary values her own time more highly than Jane’s. Which rung of the ladder would Jane be on at this point?',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: 'c3010144-e5c5-435a-be90-576d8812eea2',
  //       option: 'Assumptions',
  //       description:
  //         'Correct, Jane is making assumptions based on the meanings she decided on regarding Mary being late.',
  //       img: 'charImage2',
  //     },
  //     {
  //       id: '310f937a-6325-410d-afe6-8e0805356026',
  //       option: 'Actions',
  //       description:
  //         'Incorrect, Jane has not taken action yet. She is making assumptions based on the meaning she has placed based on her selected data.',
  //       img: 'charImage3',
  //     },
  //   ],
  //   answer: '',
  //   answers: ['c3010144-e5c5-435a-be90-576d8812eea2', '310f937a-6325-410d-afe6-8e0805356026'],
  //   answer_description:
  //     'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 3
  // {
  //   id: '53129728-a70e-4351-8828-a98bdfeeb58b',
  //   question:
  //     'Jane concludes that it’s not worth bothering to meet up in future, because Mary obviously doesn’t want to see her. Which rung level would Jane be at this point?',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: '49aea3b2-dac4-4bb5-beef-ab7a433acd1e',
  //       option: 'Conclusion',
  //       description:
  //         'Correct, Jane has drawn to a conclusion, based on her previous assumption, that Mary doesn"t want to see her.',
  //       img: 'charImage2',
  //     },
  //     {
  //       id: '8a6b7c60-835d-4d98-91c7-09a57afdaffa',
  //       option: 'Actions',
  //       description:
  //         'Incorrect, Jane has not taken any action yet. She has drawn to the conclusion, based on her previous assumption, that Mary doesn"t want to see her.',
  //       img: 'charImage11',
  //     },
  //   ],
  //   answer: '',
  //   answers: ['49aea3b2-dac4-4bb5-beef-ab7a433acd1e', '8a6b7c60-835d-4d98-91c7-09a57afdaffa'],
  //   answer_description:
  //     'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 4
  // {
  //   id: 'cdd3b6cb-53c8-4d4d-bfa3-fda704d14feb',
  //   question: 'When Mary suggests meeting the next week, Jane makes an excuse to avoid it.',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: '47e5db8b-8f5c-4049-890d-b72587b9753d',
  //       option: 'Conclusion',
  //       description:
  //         'Incorrect, Jane has now taken action by making an excuse to avoid a meeting next week.',
  //       img: 'charImage11',
  //     },
  //     {
  //       id: 'efcb9815-cb92-46c7-830f-6dfbfc0cf8c4',
  //       option: 'Actions',
  //       description:
  //         'Correct, Jane has now taken action by making an excuse to avoid meeting with Mary again.',
  //       img: 'charImage2',
  //     },
  //   ],
  //   answer: '',
  //   answers: ['47e5db8b-8f5c-4049-890d-b72587b9753d', 'efcb9815-cb92-46c7-830f-6dfbfc0cf8c4'],
  //   answer_description:
  //     'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 5
  // {
  //   title: 'Summary',
  //   content:
  //     'Jane started by selecting observable data, translated it based on the meaning she made  of this data, made assumptions, then drew conclusions, and took action . ',
  //   id: '738932af-19fb-412e-8cbd-9d988e4f7a2f',
  //   question: '',
  //   question_img: '',
  //   options: [],
  //   answer: '',
  //   answers: [],
  //   answer_description: '',
  //   type: QuestionType.INFOBLOCK,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
];
export const course_chat_questions2: CourseChatQuestion[] = [
  // 0
  {
    title: 'Scenario: Groupthink',
    content:
      'During a brainstorming session, everyone seems to agree on a particular approach to solve a problem.',
    id: '67asw-6d54-4fe5-94df-32rsfzcseer',
    question: '',
    question_img: 'intro',
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content: 'Carlos suggests:  "I think we should tackle the problem by following this approach."',
    id: 'sdfew65-6d54-4fe5-94df-vsdf435fq',
    question: '',
    question_img: chat1,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content: 'Stephen agrees: "That sounds good to me."',
    id: 'ndrt342-6d54-4fe5-94df-arwr3522',
    question: '',
    question_img: chat2,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content: 'Dacia replies: "Yeah, I agree. Let´s go with that."',
    id: 'sdfwet5-6d54-4fe5-94df-vbsdt342',
    question: '',
    question_img: chat3,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content:
      'Val expressing her excitement: "Seems like we´re all in agreement. Let´s move forward with this plan."',
    id: 'nfghtr4-6d54-4fe5-94df-967hse2s',
    question: '',
    question_img: chat4,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: '',
    content:
      'Michel, the team leader says: "Great, it looks like we have our solution. Let´s get to work."',
    id: 'otyj-56hs-4fe5-94df-wer46hds',
    question: '',
    question_img: chat5,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  // 1
  // {
  //   id: '400a9165-b5c9-4962-874e-de9bc4b7ff7b',
  //   question:
  //     'Step 2: Authentic praise. Which response would demonstrate Kevin providing authentic praise? ',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: 'a1334757-e7d0-4084-8b18-5c135eed8128',
  //       option:
  //         '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
  //       description: '',
  //       img: 'charImage3',
  //     },
  //     {
  //       id: 'ca2c8cac-9ef6-4fd5-af23-84b2f5cd1e04',
  //       option: '"You were okay, I guess."',
  //       description: '',
  //       img: 'charImage2',
  //     },
  //   ],
  //   answer:
  //     '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
  //   answers: ['a1334757-e7d0-4084-8b18-5c135eed8128'],
  //   answer_description:
  //     '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 2
  // {
  //   id: 'f28579cd-5149-4492-9c15-add68f61f47e',
  //   question:
  //     'Jane decides that Mary simply couldn’t be bothered to turn up on time, and that Mary values her own time more highly than Jane’s. Which rung of the ladder would Jane be on at this point?',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: 'c3010144-e5c5-435a-be90-576d8812eea2',
  //       option: 'Assumptions',
  //       description:
  //         'Correct, Jane is making assumptions based on the meanings she decided on regarding Mary being late.',
  //       img: 'charImage2',
  //     },
  //     {
  //       id: '310f937a-6325-410d-afe6-8e0805356026',
  //       option: 'Actions',
  //       description:
  //         'Incorrect, Jane has not taken action yet. She is making assumptions based on the meaning she has placed based on her selected data.',
  //       img: 'charImage3',
  //     },
  //   ],
  //   answer: '',
  //   answers: ['c3010144-e5c5-435a-be90-576d8812eea2', '310f937a-6325-410d-afe6-8e0805356026'],
  //   answer_description:
  //     'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 3
  // {
  //   id: '53129728-a70e-4351-8828-a98bdfeeb58b',
  //   question:
  //     'Jane concludes that it’s not worth bothering to meet up in future, because Mary obviously doesn’t want to see her. Which rung level would Jane be at this point?',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: '49aea3b2-dac4-4bb5-beef-ab7a433acd1e',
  //       option: 'Conclusion',
  //       description:
  //         'Correct, Jane has drawn to a conclusion, based on her previous assumption, that Mary doesn"t want to see her.',
  //       img: 'charImage2',
  //     },
  //     {
  //       id: '8a6b7c60-835d-4d98-91c7-09a57afdaffa',
  //       option: 'Actions',
  //       description:
  //         'Incorrect, Jane has not taken any action yet. She has drawn to the conclusion, based on her previous assumption, that Mary doesn"t want to see her.',
  //       img: 'charImage11',
  //     },
  //   ],
  //   answer: '',
  //   answers: ['49aea3b2-dac4-4bb5-beef-ab7a433acd1e', '8a6b7c60-835d-4d98-91c7-09a57afdaffa'],
  //   answer_description:
  //     'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 4
  // {
  //   id: 'cdd3b6cb-53c8-4d4d-bfa3-fda704d14feb',
  //   question: 'When Mary suggests meeting the next week, Jane makes an excuse to avoid it.',
  //   question_img: 'charImage1',
  //   options: [
  //     {
  //       id: '47e5db8b-8f5c-4049-890d-b72587b9753d',
  //       option: 'Conclusion',
  //       description:
  //         'Incorrect, Jane has now taken action by making an excuse to avoid a meeting next week.',
  //       img: 'charImage11',
  //     },
  //     {
  //       id: 'efcb9815-cb92-46c7-830f-6dfbfc0cf8c4',
  //       option: 'Actions',
  //       description:
  //         'Correct, Jane has now taken action by making an excuse to avoid meeting with Mary again.',
  //       img: 'charImage2',
  //     },
  //   ],
  //   answer: '',
  //   answers: ['47e5db8b-8f5c-4049-890d-b72587b9753d', 'efcb9815-cb92-46c7-830f-6dfbfc0cf8c4'],
  //   answer_description:
  //     'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
  //   type: QuestionType.CHAT,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
  // // 5
  // {
  //   title: 'Summary',
  //   content:
  //     'Jane started by selecting observable data, translated it based on the meaning she made  of this data, made assumptions, then drew conclusions, and took action . ',
  //   id: '738932af-19fb-412e-8cbd-9d988e4f7a2f',
  //   question: '',
  //   question_img: '',
  //   options: [],
  //   answer: '',
  //   answers: [],
  //   answer_description: '',
  //   type: QuestionType.INFOBLOCK,
  //   chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
  //   course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  // },
];
export const course_chat_questions3: CourseChatQuestion[] = [
  // 0
  {
    title: 'Scenario:',
    content:
      'Kevin and Devon are working on a group project presentation for their history class. Kevin is giving Devon some feedback using the 5 step brain-friendly approach.',
    id: '234asz-6d54-4fe5-94df-ba129ejajsdf',
    question: '',
    question_img: 'intro',
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  {
    title: 'Step 1: Prime with, "Yes."',
    content:
      'Kevin: "Hey, Devon, do you have a few minutes to talk about our group presentation in history class?"',
    id: '34745s-6d54-4fe5-94df-asr353231',
    question: '',
    question_img: chat2,
    options: [],
    answer: '',
    answers: [],
    answer_description: '',
    type: QuestionType.INFOBLOCK,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },

  // 1
  {
    id: '400a9165-b5c9-4962-874e-de9bc4b7ff7b',
    question:
      'Step 2: Authentic praise. Which response would demonstrate Kevin providing authentic praise? ',
    question_img: chat2,
    options: [
      {
        id: 'a1334757-e7d0-4084-8b18-5c135eed8128',
        option:
          '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
        description: '',
        img: chat6,
      },
      {
        id: 'ca2c8cac-9ef6-4fd5-af23-84b2f5cd1e04',
        option: '"You were okay, I guess."',
        description: '',
        img: chat6,
      },
    ],
    answer:
      '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
    answers: ['a1334757-e7d0-4084-8b18-5c135eed8128'],
    answer_description:
      '"You did an awesome job with the introduction and conclusion. Your speaking skills have really improved, and it made our presentation stand out."',
    type: QuestionType.CHAT,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  // // 2
  {
    id: 'f28579cd-5149-4492-9c15-add68f61f47e',
    question: 'Step 3: Provide the data point. Which statement is the best for Kevin to say?',
    question_img: chat2,
    options: [
      {
        id: 'c3010144-e5c5-435a-be90-576d8812eea2',
        option:
          'Kevin: "However, you said you´d finish the slide on World War II by Thursday evening, but I didn´t receive it until Sunday morning."',
        img: chat2,
      },
      {
        id: '310f937a-6325-410d-afe6-8e0805356026',
        option: '"You were late with the slide."',
        img: 'charImage3',
      },
    ],
    answer: '',
    answers: ['c3010144-e5c5-435a-be90-576d8812eea2'],
    answer_description:
      'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
    type: QuestionType.CHAT,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  // // 3
  {
    id: '53129728-a70e-4351-8828-a98bdfeeb58b',
    question: 'Step 4: Share the Impact statement. Which statement is best for sharing the impact?',
    question_img: chat2,
    options: [
      {
        id: '49aea3b2-dac4-4bb5-beef-ab7a433acd1e',
        option: '"You made me feel unprepared."',
        img: 'charImage2',
      },
      {
        id: '9a6b7c60-835d-4d98-91c7-09a57afdaffa',
        option:
          '"Because I got the slide late, I had to rush and didn´t have enough time to practice my part, so I felt a bit unprepared for the presentation."',
        img: 'charImage11',
      },
    ],
    answer: '',
    answers: ['9a6b7c60-835d-4d98-91c7-09a57afdaffa'],
    answer_description:
      'I am trying. My silence isn’t because of a lack of effort. You don’t understand what this feels like for me.',
    type: QuestionType.CHAT,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  // // 4
  {
    id: 'cdd3b6cb-53c8-4d4d-bfa3-fda704d14feb',
    question:
      'Step 5: Check in and end with a collaborative question. Which is the best way to state the question?',
    question_img: 'charImage1',
    options: [
      {
        id: '47e5db8b-8f5c-4049-890d-b72587b9753d',
        option: '"What´s your problem? You need to get it together next time."',
        img: 'charImage11',
      },
      {
        id: 'efcb9815-cb92-46c7-830f-6dfbfc0cf8c4',
        option:
          '"Were you aware of the impact? What´s your take? You´re usually so organized. Is everything okay? How can we stay on track for our next project?"',
        img: 'charImage2',
      },
    ],
    answer: '',
    answers: ['efcb9815-cb92-46c7-830f-6dfbfc0cf8c4'],
    answer_description:
      '"Were you aware of the impact? What´s your take? You´re usually so organized. Is everything okay? How can we stay on track for our next project?"',
    type: QuestionType.CHAT,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
  // // 5
  {
    id: '345asfz-53c8-4d4d-bfa3-345wwqw14',
    question:
      'Outcome: If Kevin used the five-step approach on giving feedback, what is Devon´s likely response.',
    question_img: chat1,
    options: [
      {
        id: '47e5db8b-8f5c-4049-890d-b72587b9753d',
        option:
          '"I didn´t realize it would affect your preparation. I´m sorry for the delay; I had unexpected family stuff. I´ll communicate better and be on time."',
        description: '',
        img: 'charImage11',
      },
      {
        id: 'efcb9815-cb92-46c7-830f-6dfbfc0cf8c4',
        option: '"Wow, okay. I didn´t realize it was such a big deal. Whatever."',
        description: '',
        img: 'charImage2',
      },
    ],
    answer: '',
    answers: ['47e5db8b-8f5c-4049-890d-b72587b9753d'],
    answer_description:
      '"I didn´t realize it would affect your preparation. I´m sorry for the delay; I had unexpected family stuff. I´ll communicate better and be on time."',
    type: QuestionType.CHAT,
    chapter_id: '819396a0-4ec1-4802-8939-478146f4f2c8',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
  },
];
export const course_questions: CourseQuestion[] = [
  {
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    id: 'c717561a-145a-401b-99b5-2092863fd4f0',
    question: 'Why does the scenario above demonstrate risky shift? Select all that apply.',
    options: [
      {
        id: '2e3c9d5d-08c6-44c0-87b5-267981de6d70',
        option: 'One team member suggests taking a big risk to meet the tight deadline.',
      },
      {
        id: 'aa523bf5-db38-4942-a049-c99d86777448',
        option: 'Another member isn´t so sure about it and worries about what could go wrong.',
      },
      {
        id: '4e4d06f0-f793-4b1b-9ea8-1b0d8f99d063',
        option:
          'The rest of the team jumps in, saying they´ll handle any problems together and they´re all for it.',
      },
      {
        id: 'd6e69cf3-1e5c-4d0c-a339-bab58ca999ea',
        option: 'The team leader agrees, thinking everyone´s on board.',
      },
    ],
    answers: [
      '2e3c9d5d-08c6-44c0-87b5-267981de6d70',
      'aa523bf5-db38-4942-a049-c99d86777448',
      '4e4d06f0-f793-4b1b-9ea8-1b0d8f99d063',
      'd6e69cf3-1e5c-4d0c-a339-bab58ca999ea',
    ],
    answer_description:
      'All demonstrate risky shift. Starting with a Risky Idea: One team member suggests taking a big risk to meet the tight deadline. Someone Raises Concerns: Another member isn´t so sure about it and worries about what could go wrong. Everyone Gets Excited: But then, the rest of the team jumps in, saying they´ll handle any problems together and they´re all for it. Leader Gives the Green Light: Finally, the team leader agrees, thinking everyone´s on board.',
    type: QuestionType.CHECKBOX,
  },
  {
    chapter_id: 'ab7346f0-d744-4c6f-b53f-d3d9e2710b10',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    id: 'f29cbd21-5172-4931-abd9-965a85a0ed8b',
    question: 'Why does the example above demonstrate groupthink? Select all that apply.',
    options: [
      {
        id: '288f5edf-cd94-45a7-8719-7839bafd60e2',
        option:
          'When one person suggests a solution, everyone else agrees right away without really thinking about it.',
      },
      {
        id: '5e2236c5-c760-4208-a1eb-b5810fac85b6',
        option:
          'Nobody offers different ideas or challenges the one that´s suggested. They all just go along with it.',
      },
      {
        id: '73785adc-1646-4c02-8691-389d9afb91da',
        option:
          'The leader assumes everyone´s in agreement because nobody speaks up against the idea.',
      },
      {
        id: 'acee5945-ea31-4826-b59a-5c92e98eceb4',
        option:
          'Without exploring other options or thinking it through, they decide to go with the first suggestion.',
      },
    ],
    answers: [
      '288f5edf-cd94-45a7-8719-7839bafd60e2',
      '5e2236c5-c760-4208-a1eb-b5810fac85b6',
      '73785adc-1646-4c02-8691-389d9afb91da',
      'acee5945-ea31-4826-b59a-5c92e98eceb4',
    ],
    answer_description:
      'All of these demonstrate groupthink. Everyone Agrees Quickly: When one person suggests a solution, everyone else agrees right away without really thinking about it. No One Questions the Idea: Nobody offers different ideas or challenges the one that´s suggested. They all just go along with it.Leader Thinks Everyone´s On Board: The leader assumes everyone´s in agreement because nobody speaks up against the idea. They Go with the First Idea: Without exploring other options or thinking it through, they decide to go with the first suggestion.',
    type: QuestionType.CHECKBOX,
  },
  {
    chapter_id: '997eb5d4-1524-436f-98eb-e8c5a9826241',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    id: '1328557a-6eb2-48e0-a30a-3a955f4dc8e5',
    question: ' How should you respond if a friend makes a mistake?',
    options: [
      {
        id: 'f5d21945-2514-4ffa-aace-8de0a11fcc49',
        option: 'Get upset and blame them',
      },
      {
        id: '84c70aa2-1c3b-4e2c-aea1-4fd9757bacf0',
        option: 'Offer help and understanding',
      },
      {
        id: '26554f24-5f3a-46b4-b1e3-c65fb2de9bcb',
        option: 'Ignore the mistake and move on',
      },
      {
        id: '2b305d72-3fa5-4b68-9f6b-12f8e8ef3e01',
        option: 'Laugh at them and make fun of the mistake',
      },
    ],
    answers: ['84c70aa2-1c3b-4e2c-aea1-4fd9757bacf0'],
    answer_description: 'Be patient: offer help and understanding',
    wrong_answer_description: 'Be patient: offer help and understanding',
    type: QuestionType.RADIO,
  },
  {
    chapter_id: '997eb5d4-1524-436f-98eb-e8c5a9826241',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    id: '3835b164-272c-4f8e-b3bc-9166739a065e',
    question: ' What is a recommended action if you´re angry and faced with a problem?',
    options: [
      {
        id: '75faf531-3919-4b91-ac69-f07f92124599',
        option: 'Try to fix the problem immediately',
      },
      {
        id: '637febce-6453-4b0d-a49c-d13739ad5167',
        option: 'Take a deep breath and calm down before addressing the problem',
      },
      {
        id: '88bdee1e-7e38-4817-ba75-3461bfcf0a15',
        option: 'Ignore the problem and walk away',
      },
      {
        id: '755afa66-b171-4e35-9e42-72475e48d86b',
        option: 'Express your anger loudly to let off steam',
      },
    ],
    answers: ['637febce-6453-4b0d-a49c-d13739ad5167'],
    answer_description: 'Be calm: Take a deep breath and calm down before addressing the problem',
    wrong_answer_description:
      'Be calm: Take a deep breath and calm down before addressing the problem',
    type: QuestionType.RADIO,
  },
  {
    chapter_id: '997eb5d4-1524-436f-98eb-e8c5a9826241',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    id: 'c7d106a8-70af-4efa-9c8a-55b71ec9bc39',
    question: ' How should you handle a disagreement with a friend?',
    options: [
      {
        id: '6628c138-b96b-4d7d-8476-c00e72ca8f9b',
        option: 'Talk to everyone except your friend about the problem',
      },
      {
        id: 'b7fe040e-1c55-4c93-a972-9b9377e4d9fe',
        option: 'Avoid talking about the problem and hope it goes away',
      },
      {
        id: '5a151a73-dd8d-4f88-b1ad-d8ac7f9b1e9f',
        option: 'Discuss the problem directly with your friend in a respectful manner',
      },
      {
        id: '76830739-b6ae-47ac-a883-dc83bdbe73d2',
        option: 'Spread rumors and gossip to make your point',
      },
    ],
    answers: ['5a151a73-dd8d-4f88-b1ad-d8ac7f9b1e9f'],
    answer_description:
      'Communicate well: Discuss the problem directly with your friend in a respectful manner',
    wrong_answer_description:
      'Communicate well: Discuss the problem directly with your friend in a respectful manner',
    type: QuestionType.RADIO,
  },
  {
    chapter_id: '997eb5d4-1524-436f-98eb-e8c5a9826241',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    id: 'fad468de-42f1-432a-9aa2-1cbdad3bc7ce',
    question: 'What is a constructive way to resolve a disagreement within a group?',
    options: [
      {
        id: 'c28d5d77-7662-4f11-9048-6270e4185bd1',
        option: 'Insist on your own way and ignore others opinions',
      },
      {
        id: 'bf99e7d4-8768-4c16-a806-39000a1e7acf',
        option: 'Leave the group and find new friends',
      },
      {
        id: '1f0b5a2d-8777-4a46-a9b4-87390656447e',
        option: 'Ask for everyone´s input and suggest compromises for a solution',
      },
      {
        id: '3050782a-4ff2-4be4-a147-3b921a518b50',
        option: 'Start a fight to prove your point',
      },
    ],
    answers: ['1f0b5a2d-8777-4a46-a9b4-87390656447e'],

    answer_description:
      'Find a solution for everyone: Ask for everyone´s input and suggest compromises for a solution.',
    wrong_answer_description:
      'Find a solution for everyone: Ask for everyone´s input and suggest compromises for a solution.',
    type: QuestionType.RADIO,
  },
];

export const course_sorting_questions: CourseSortingQuestion[] = [
  {
    id: '599ca2ec-19da-4328-9d44-55894a72ca9c',
    chapter_id: '997eb5d4-1524-436f-98eb-e8c5a9826241',
    course_id: '4bb48c33-f276-47d9-ac6b-587d1605484d',
    type: QuestionType.SORTING,
    questions: [
      {
        id: 'f4ea9ad7-43a9-4faf-a938-d3e1f6280ff2',
        question:
          'During a team meeting, Mark criticizes his colleague´s ideas in a hostile and confrontational manner, undermining their confidence and creating a tense atmosphere. Other team members feel uncomfortable speaking up, fearing Mark´s aggressive reactions.',
      },
      {
        id: '507c0f86-c4c1-40fe-b951-f6740644ec68',
        question:
          'During a group project, Sarah consistently takes credit for the team`s ideas and contributions, failing to acknowledge the efforts of her teammates. This behavior creates resentment among the team members, leading to a breakdown in trust and cooperation.',
      },
      {
        id: '1a92bb70-1f9a-4160-80b7-279aae68528c',
        question:
          'During a project presentation, John exaggerates the team´s achievements and glosses over important issues to impress stakeholders. His dishonesty leads to misunderstandings and erodes trust within the team, jeopardizing the project´s success.',
      },
      {
        id: '388305b7-0432-4c72-a625-2889d80fe2e9',
        question:
          'Sarah, a key team member, consistently fails to provide updates on her progress or share important information with the rest of the team. Her lack of communication leads to confusion and misunderstandings, hindering collaboration and productivity.',
      },
      {
        id: '10e61caa-c506-4cd9-ac7e-4bb82e00de93',
        question:
          'James agrees to complete a crucial task by a specific deadline but repeatedly fails to deliver on time, causing delays in the project timeline. His teammates feel frustrated and disappointed by his lack of reliability, impacting the team´s overall productivity and morale.',
      },
      {
        id: '1ae36c28-677b-4827-889f-1d0d33d718b8',
        question:
          'Emily consistently complains about the team´s direction and criticizes her colleagues behind their backs, spreading negativity within the group. Her pessimistic attitude affects team morale and hinders collaboration, making it challenging to achieve common goals.',
      },
      {
        id: '1cce36c28-677b-4827-889f-1d0d33d718b8',
        question:
          'David routinely procrastinates on his assigned tasks and relies on his teammates to pick up the slack, causing resentment and frustration among the group. Despite repeated reminders, David fails to contribute effectively, impacting the team´s overall performance.',
      },
    ],
    options: [
      {
        id: '2b0edc27-3c8a-41f6-a606-933b80b16908',
        option: 'Selfishness',
      },
      {
        id: '5d1bab95-cb50-4149-a597-d916eb47511b',
        option: 'Unreliability',
      },
      {
        id: 'd0bec340-3b88-457d-b5d0-8370713b8e39',
        option: 'Aggressive Behavior',
      },
      {
        id: '727d0621-42ae-441d-aab0-017348bb17eb',
        option: 'Negative Attitude',
      },
      {
        id: '6d13a6d2-6437-4e80-aa7e-e1556fed2037',
        option: 'Dishonesty',
      },
      {
        id: '201c39b6-1bbf-451b-8be6-68c341035b74',
        option: 'Laziness',
      },
      {
        id: '3e8c429f-e916-4152-971b-08490ffc490b',
        option: 'Lack of Communication',
      },
    ],
    answers: {
      '507c0f86-c4c1-40fe-b951-f6740644ec68': {
        id: '2b0edc27-3c8a-41f6-a606-933b80b16908',
        option: 'Selfishness',
      },
      '10e61caa-c506-4cd9-ac7e-4bb82e00de93': {
        id: '5d1bab95-cb50-4149-a597-d916eb47511b',
        option: 'Unreliability',
      },
      'f4ea9ad7-43a9-4faf-a938-d3e1f6280ff2': {
        id: 'd0bec340-3b88-457d-b5d0-8370713b8e39',
        option: 'Aggressive Behavior',
      },
      '1ae36c28-677b-4827-889f-1d0d33d718b8': {
        id: '727d0621-42ae-441d-aab0-017348bb17eb',
        option: 'Negative Attitude',
      },
      '1a92bb70-1f9a-4160-80b7-279aae68528c': {
        id: '6d13a6d2-6437-4e80-aa7e-e1556fed2037',
        option: 'Dishonesty',
      },
      '1cce36c28-677b-4827-889f-1d0d33d718b8': {
        id: '201c39b6-1bbf-451b-8be6-68c341035b74',
        option: 'Laziness',
      },
      '388305b7-0432-4c72-a625-2889d80fe2e9': {
        id: '3e8c429f-e916-4152-971b-08490ffc490b',
        option: 'Lack of Communication',
      },
    },
  },
];
